/**  图片验证码弹窗组件 **/
import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Input, message, Row, Col } from 'antd';
import { callApi } from 'utils';
import './index.less';

const FormItem = Form.Item;

class PictureValidate extends (PureComponent || Component) {
	constructor (props) {
		super(props);

		// initial state
		this.state = {
			picture: '',
			confirmLoading: false,
		};
	}

	componentWillReceiveProps (nextProps) {
		const { visible, form } = this.props;
		if (!visible && nextProps.visible) {
			form.setFieldsValue({
				verifyCode: '',
			});
			this.newPicture();
		}
	}

	newPicture = () => {
		callApi({
			prefix: '/evh',
			api: '/PictureValidate/newPicture',
			success: (res) => {
				this.setState({ picture: res });
			},
		});
	}

	onOk = () => {
		const { onOk, form } = this.props;
		const { validateFieldsAndScroll, setFields } = form;
		validateFieldsAndScroll(['verifyCode'], (errors, values) => {
			if (errors) {
				return;
			}

			this.setState({ confirmLoading: true });
			callApi({
				prefix: '/evh',
				api: '/PictureValidate/validateCode',
				data: { code: values.verifyCode },
				success: (res) => {
					this.setState({ confirmLoading: false });
					if (res) {
						onOk(values.verifyCode);
					} else {
						setFields({
							verifyCode: {
								value: values.verifyCode,
								errors: [new Error('验证码错误')]
							}
						});
					}
				},
				error: (err) => {
					message.error(err.errorDescription || '系统异常，请稍候再试', 1.5);
					this.setState({
						confirmLoading: false
					});
				}
			});
		});
	}

	render () {
		const { visible, title, form, onCancel } = this.props;
		const { picture, confirmLoading } = this.state;
		const { getFieldDecorator, getFieldError } = form;
		const prefixCls = 'picture-validate';
		const formItemLayout = {
			labelCol: { span: 7 },
			wrapperCol: { span: 17 },
		};
		const codeError = getFieldError('verifyCode');

		return (
			<Modal
				visible={visible}
				title={title}
				onCancel={onCancel}
				onOk={this.onOk}
				confirmLoading={confirmLoading}
			>
				<div className={prefixCls}>
					<Form>
						<FormItem
							{...formItemLayout}
							label="图片验证码"
							required={false}
							help={''}
						>
							<div className={`${prefixCls}-content`}>
								{getFieldDecorator('verifyCode', {
									rules: [{
										required: true, message: '请输入图片验证码'
									}],
									validateTrigger: 'onBlur',
								})(
									<Input style={{ width: 180 }} autocomplete="off" />
								)}
								{codeError && (
									<span className={`${prefixCls}-error`}>{codeError}</span>
								)}
							</div>
						</FormItem>
						<Row>
							<Col span={7}/>
							<Col span={17}>
								<div className={`${prefixCls}-content`}>
									<div className={`${prefixCls}-text`}>请输入图中的字母或数字，不区分大小写</div>
									<div className={`${prefixCls}-picture`}>
										<img src={`data:image/gif;base64,${picture}`} onClick={this.newPicture} />
										<span onClick={this.newPicture}>换一个</span>
									</div>
								</div>
							</Col>
						</Row>
					</Form>
				</div>
			</Modal>
		);
	}
}

PictureValidate.propTypes = {
	visible: PropTypes.bool,
	title: PropTypes.string,
	onOk: PropTypes.func,
	onCancel: PropTypes.func,
};

PictureValidate.defaultProps = {
	title: '请输入图片验证码'
};

export default Form.create()(PictureValidate);
